import React from 'react'

import card from '../../styles/components/livePage/card'
import livePageStyle from '../../styles/components/livePage/live_page'
import Card from './Card'

const TopStories = ({ topStories }) => (
  <div className='top-stories'>
    <div className='top-stories-title'>Top Stories</div>
    <div className='top-stories-list'>
      {topStories.map((story, index) => {
        return <Card style={card} story={story} key={index} />
      })}
    </div>
    <style jsx>{livePageStyle}</style>
  </div>
)

export default TopStories
